var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke-color-main",
    d: "M100,8.616A54.03,54.03,0,0,0,45.971,62.645C45.971,92.485,100,186.718,100,186.718s54.029-94.233,54.029-124.073A54.03,54.03,0,0,0,100,8.616ZM100,89a24.362,24.362,0,1,1,24.362-24.362A24.362,24.362,0,0,1,100,89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke-color-main",
    d: "M100,8.616A54.03,54.03,0,0,0,45.971,62.645C45.971,92.485,100,186.718,100,186.718s54.029-94.233,54.029-124.073A54.03,54.03,0,0,0,100,8.616ZM100,89a24.362,24.362,0,1,1,24.362-24.362A24.362,24.362,0,0,1,100,89Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/maps.2f15822faae70ba08a6799f1a1cf15e8.svg";
export { ForwardRef as ReactComponent };